<mat-checkbox (change)="onChange($event)" [checked]="defaultChecked" [disabled]="isDisabled"
  [color]="defaultColor"
  disableRipple
  >
  <span id="shared-checkbox-text" class="checkbox-text">
    <app-text id="shared-checkbox-text-data" [textStyleType]="fontType">{{
      checkboxData
      }}</app-text>
  </span>
</mat-checkbox>